import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { Box, SecondaryView, ContextualDrawer, Button } from '@amzn/storm-ui';
import { C as CountrySelectorContent } from './CountrySelectorContent-D-ck8LHa.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';

const StyledSecondaryView = /*#__PURE__*/styled(SecondaryView).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1kq6ien-0"
})(["margin-bottom:", ";"], ({
  theme
}) => theme.countryList.secondaryView.footer.height);
const FooterContent = /*#__PURE__*/styled(ContextualDrawer).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1kq6ien-1"
})(["height:", ";"], ({
  theme
}) => theme.countryList.secondaryView.footer.height);
const ContextualDrawerApplyButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1kq6ien-2"
})(["width:100%;"]);
const CountrySelectorSecondaryView = ({
  children,
  id,
  isOpen,
  onClose,
  onSelect,
  countries,
  trigger,
  renderOptionsEnd,
  renderOptionsStart,
  applyButtonText,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledSecondaryView, _extends({}, rest, {
    id: id,
    isOpen: isOpen,
    onClose: onClose,
    padding: "none",
    closeButtonLabel: countries.length > 0 ? formatMessage({
      id: 'cancel-button-label'
    }) : formatMessage({
      id: 'done-button-label'
    })
  }), /*#__PURE__*/React__default.createElement(CountrySelectorContent, {
    id: id,
    countries: countries,
    onClose: onClose,
    onSelect: onSelect
  }, !!renderOptionsStart && /*#__PURE__*/React__default.createElement(Box, {
    padding: "small base",
    square: true
  }, renderOptionsStart()), children, !!renderOptionsEnd && /*#__PURE__*/React__default.createElement(Box, {
    padding: "small base",
    square: true
  }, renderOptionsEnd())), countries.length > 0 && /*#__PURE__*/React__default.createElement(FooterContent, {
    isOpen: isOpen,
    withCloseButton: false
  }, /*#__PURE__*/React__default.createElement(ContextualDrawerApplyButton, {
    onClick: onSelect,
    variant: "primary"
  }, applyButtonText || formatMessage({
    id: 'apply-button-label'
  })))), /*#__PURE__*/React__default.cloneElement(trigger));
};

export { CountrySelectorSecondaryView as C };
//# sourceMappingURL=CountrySelectorSecondaryView-BPGzK2_V.js.map
